import { CollectionService } from './index';

const SnpService = CollectionService('snps');

export default SnpService;
